import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { Bars, Sort, SortDown, SortUp } from '../../../components/Icon';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Modal, ModalControls } from '../../../components/Modal';
import { selectKanbanColumnSort, selectKanbanSort } from '../selectors';
import { setKanbanColumnSort } from '../actions';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
ButtonComponent;

const Container = styled.div``;
const STATE = {
  sort: false,
};

/* eslint-disable react/prefer-stateless-function */
class KanbanColumnFilterComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get currentSortByName() {
    return (this.props.sort?.[0] || {}).sortBy;
  }

  get currentSortByDesc() {
    return (this.props.sort?.[0] || {}).desc;
  }

  setTo(name) {
    let current = this.props.sort?.[0] || {};
    this.props.setTo(name, !current.desc);
  }

  render() {
    return (
      <>
        <ButtonComponent size={'btn-sm'} style={'ButtonSoftPrimary'} onClick={this.setStateFn({ sort: !this.state.sort })}>
          <Sort />
        </ButtonComponent>
        {this.state.sort ? this.renderModal() : null}
      </>
    );
  }

  renderModal() {
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanbanColumnFilter.sorting')}>
        <Container>
          <VBox center vCenter gap={12}>
            <div>Sort by:</div>
            {['id', 'regplate', 'vin', 'counter', 'brand_name'].map(name => (
              <Button primary={name == this.currentSortByName} onClick={() => this.setTo(name)} key={name}>
                {console.log('Debug:', name, this.currentSortByName, this.currentSortByDesc)}
                {this.currentSortByName == name ? this.currentSortByDesc ? <SortDown /> : <SortUp /> : null}&nbsp;
                {this.lbl(`vehicle.property.${name}`)}
              </Button>
            ))}
          </VBox>
          <ModalControls>
            <Button isPrimary onClick={this.reset.bind(this)}>
              {this.lbl('ok')}
            </Button>
          </ModalControls>
        </Container>
      </Modal>
    );
  }
}

KanbanColumnFilterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    sort: selectKanbanColumnSort(ownProps.column.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setTo(sortBy, desc, callback) {
      dispatch(setKanbanColumnSort(ownProps.column.id, sortBy, desc));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanColumnFilter = compose(withConnect, withRouter)(KanbanColumnFilterComp);
